import React from 'react';

export const SystemCard = ({ badge, badgeClassName, title, subtitle, actions, children }) => (
    <div className="flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white">
        <div className="flex items-center gap-3 border-b border-slate-200 p-4">
            <span
                className={`flex size-11 shrink-0 items-center justify-center rounded-md text-[15px] font-bold text-white ${badgeClassName}`}
            >
                {badge}
            </span>
            <div className="flex flex-col">
                <h4 className="m-0 text-[15px] font-bold text-slate-900">{title}</h4>
                <span className="text-[13px] text-slate-500">{subtitle}</span>
            </div>
        </div>
        {children}
        {actions ? <div className="mt-auto flex flex-wrap gap-2 bg-slate-50 p-4">{actions}</div> : null}
    </div>
);

export const CardRow = ({ label, children }) => (
    <div className="flex items-center justify-between gap-4 border-b border-slate-200 px-4 py-3 text-[13px]">
        <span className="text-slate-500">{label}</span>
        <span className="font-medium text-slate-900">{children}</span>
    </div>
);
